<template>
  <div class="questionaire-template-item-widget" @click.self="onTemplateSelected">
    <div class="questionaire-template-item">
      <div class="questionaire-template-item-header">
        <div class="questionaire-template-item-header-title" @click="onTemplateSelected">
          {{ item.title }}
        </div>
        <div class="email-template-item-options">
          <dropdown-menu>
            <ul>
              <li>
                <a @click="updateTemplate()">Edit Template
                </a>
              </li>
              <li>
                <app-dialog title="Delete Template" ask="Are you sure you want to delete this template?"
                  yesText="Delete" noText="Cancel" @onComfirm="deleteTemplate()">
                  <a>Delete Template</a>
                </app-dialog>
              </li>
            </ul>
          </dropdown-menu>
        </div>
      </div>
      <div class="questionaire-template-item-body" @click="onTemplateSelected">
        <div class="questionaire-template-item-body-text">
          {{ htmlToText(item.description) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "emailTemplateItem",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
    };
  },
  watch: {},
  mounted() {
    let vm = this;

  },
  methods: {
    onTemplateSelected(e) {
      this.$emit("onTemplateSelected", e);
    },
    deleteTemplate() {
      this.$emit("deleteTemplate", this.item);
    },
    updateTemplate() {
      this.$emit("updateTemplate", this.item);
    }
  },
};
</script>
<style lang="scss" scoped>
.questionaire-template-item-widget {
  transition: all 0.3s ease-in-out;
  width: 100%;
  display: flex;
  width: 100%;

  &.active {
    background: #f4f4f4;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
    transition: 0.1s ease-in-out;
  }

  .questionaire-template-item {
    padding: 10px 10px;
    transition: 0.3s ease-in-out;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;

    &:hover {
      background: #f4f4f4;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
      transition: 0.1s ease-in-out;
    }

    .questionaire-template-item-header {
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 5px 5px;

      .questionaire-template-item-header-title {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 19px;
        color: #1c1c1c;
        width: 100%;
      }
    }

    .questionaire-template-item-body {
      .questionaire-template-item-body-text {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        color: #8e8b8b;
        text-align: left;
      }
    }
  }

}
</style>